<app-section-titulo-empreendedorismo-inovacao></app-section-titulo-empreendedorismo-inovacao>
<!-- <app-section-edital-aberto></app-section-edital-aberto> -->
<app-section-etapas-inovacao></app-section-etapas-inovacao>
<app-section-fases></app-section-fases>
<app-section-caixa-numeros></app-section-caixa-numeros>
<app-section-diretoria-executiva></app-section-diretoria-executiva>
<app-section-quero-incubar></app-section-quero-incubar>

<app-section-empresas [tipo]="tipoEmpresaIncubadas"></app-section-empresas>
<app-section-empresas [tipo]="tipoEmpresaGraduadas"></app-section-empresas>
<app-section-empresas [tipo]="tipoEmpresaParceira"></app-section-empresas>